import { Component, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {HeaderComponent} from "../../../common/header/header.component";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {NgOptimizedImage} from "@angular/common";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-insurance-information',
  imports: [
    ColoredBackgroundComponent,
    FooterComponent,
    RouterLink,
    HeaderComponent,
    FinishBoxComponent
  ],
  templateUrl: './insurance-information.component.html',
  styleUrl: './insurance-information.component.css'
})
export class InsuranceInformationComponent {
  locale = inject(LocaleService);
}
